import React from 'react';
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import LoadingSkeleton from './LoadingSkeleton';
import EmptyState from './EmptyState';

const ResponsiveTable = ({
  columns,
  rows,
  getRowKey = (row) => row.id,
  renderCell,
  loading = false,
  emptyTitle = 'No records found',
  emptyMessage = 'There are no records to display.',
  actionLabel,
  onAction,
  tableProps = {},
}) => {
  if (loading) {
    return <LoadingSkeleton rows={4} />;
  }

  if (!rows.length) {
    return (
      <EmptyState
        title={emptyTitle}
        message={emptyMessage}
        actionLabel={actionLabel}
        onAction={onAction}
      />
    );
  }

  return (
    <TableContainer component={Paper} className="responsive-table">
      <Box className="responsive-table-desktop">
        <Table {...tableProps}>
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell key={column.id} style={{ minWidth: column.minWidth }}>
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <TableRow hover key={getRowKey(row)}>
                {columns.map((column) => (
                  <TableCell key={column.id}>
                    {renderCell(column, row)}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Box>

      <Box className="responsive-table-mobile">
        {rows.map((row) => (
          <Paper
            key={getRowKey(row)}
            className="responsive-table-card"
            variant="outlined"
          >
            {columns.map((column) => (
              <Box key={column.id} className="responsive-table-card-row">
                <Typography variant="caption" color="text.secondary">
                  {column.label}
                </Typography>
                <Box>{renderCell(column, row)}</Box>
              </Box>
            ))}
          </Paper>
        ))}
      </Box>
    </TableContainer>
  );
};

export default ResponsiveTable;